import { ReactElement } from 'react';

import { FormContextValues } from '@dreryk/react-common';
import { Checkbox } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../../../../translations';

type IncludeAddressFieldProps = Pick<FormContextValues<{ includeAddress: boolean }>, 'register'>;

export const IncludeAddressField = (props: IncludeAddressFieldProps): ReactElement => {
   return (
      <Checkbox
         testId={'includeAddress'}
         label={personnelTranslationKeys.address.includeAddress}
         controller={props.register('includeAddress')}
      />
   );
};
